
import { Component, OnInit, HostListener } from '@angular/core';
import { AppSettings } from '../../app.constant';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { BatchService } from 'src/app/shared/services/batch.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { SubjectService } from 'src/app/shared/services/subject.service';
import { GradeService } from 'src/app/shared/services/grade.service';
import { Router } from "@angular/router";
import {MatSnackBar, MatTableDataSource, MatPaginator} from '@angular/material';
import { Program } from 'src/app/shared/class/program';

@Component({
  selector: 'app-grading',
  templateUrl: './grading.component.html',
  styleUrls: ['./grading.component.css']
})

export class GradingComponent implements OnInit {
  @HostListener('window:scroll', ['$event']) onScroll($event) {
    console.log($event);
  }
    batches:any;
    selectedFile: File = null;
    errorMessage:any;
    gradingForm:FormGroup;
    programs:any;
    module:any;
    modules:any;
    post :any;
    data:any;
    examYear:any;
    subjects:any;
    httpResponseMessage:any;

    FK_BatchID:any=null;
    FK_ProgramID:any=null;
    FK_ModuleID:any=null;
    FK_SubjectID:any=null;
    ExamSection:any=null;
    MarkType:any=null;
    ExamYear:any=null;
    PK_ProgramID:any=null;

    selectedProgram:Program = new Program (1,'ABC','asd','sadasdsa');
    program:any;
    datasource;
  
  constructor(
    private formbuilder:FormBuilder,
    private _batchservice:BatchService,
    private _programservice:ProgramService,
    private _moduleservice:ModuleService,
    private _subjectservice:SubjectService,
    private _gradeservice:GradeService,
    private snackBar: MatSnackBar,
    private router: Router) { }

  ngOnInit() {
      this.gradingForm =this.formbuilder.group( {
       'FK_BatchID':['', Validators],
       'FK_ProgramID':['', Validators],
       'FK_ModuleID':['', Validators],
       'FK_SubjectID':['', Validators],
       'ExamSection':['', Validators],
       'MarkType':['', Validators],
       'ExamYear':['', Validators],
        })
        this.getAllProgram();
        this.getAllBatch();
     }

  getAllBatch() :void  {
    this._batchservice.getAllBatch(AppSettings.API_ENDPOINT+AppSettings.GetAllBatch).subscribe(
     data => {    this.batches=data;
       },
     error => this.errorMessage = <any>error)
    }

  getAllProgram() :void  {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
      data => {
           this.programs=data;
      },
      error => this.errorMessage = <any>error)
    }

  getModuleByProgramID(PK_ProgramID) :void  {
    this.PK_ProgramID=PK_ProgramID;
    this._moduleservice.getAllModule(AppSettings.API_ENDPOINT+AppSettings.GetAllModule).subscribe(
    data =>
      {
        this.module=data;
        this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
   },
   error => this.errorMessage = <any>error)
    }

  getSubjectByProgramIDModuleID(PK_ModuleID):void{
      var o={PK_ModuleID:PK_ModuleID,FK_ProgramID:this.PK_ProgramID}
       this.post=JSON.stringify(o);
       this._subjectservice.getSubjectbyProgramID(AppSettings.API_ENDPOINT+AppSettings.GetSubjectByParam,this.post).subscribe(
         data => {
             this.subjects=data;
            // this.setCompanies();
                   },
        error => this.errorMessage = <any>error)
    }

  UpdateGrade(post) :void  {
        this.post=JSON.stringify(post);
        this._gradeservice.putGrade(AppSettings.API_ENDPOINT+AppSettings.UpdateGradeByParam,this.post).subscribe(
          data => {
                  this.httpResponseMessage="Marksheet  Uploaded...."
                  this.openSnackBar(this.httpResponseMessage,'');
                  this.gradingForm.reset();
                  this.GetExamByParam(this.post);
            },
          error => this.errorMessage = <any>error)
          this.router.navigate(['/grading']);
    }

    GetExamByParam(post)
    {


    }






   durationInSeconds = 2;
   openSnackBar(message: string, action: string) {
          this.snackBar.open(message,action ,{
            duration: 2000,
            verticalPosition: 'bottom'
          });
          }
}
